module.exports = __webpack_public_path__ + "img/Tessellate07.36f3f8cf.jpg";